import DropDown, { DropdownOption } from "PFComponents/dropdown/dropdown";
import ChevronIcon from "PFIcons/chevron.svg";
import DownloadIcon from "PFIcons/download.svg";
import React, { useRef, useState } from "react";

import DownloadLink from "./download_link";
import css from "./multi_download_button.module.scss";

export type DownloadReportOption = {
  uri: string;
  creationDate: Date;
};

type MultiDownloadButtonProps = {
  options: DownloadReportOption[];
};

const MultiDownloadButton = ({ options }: MultiDownloadButtonProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  const optionLinks: DropdownOption[] = options
    .sort(
      ({ creationDate: creationDateA }, { creationDate: creationDateB }) =>
        creationDateB.getTime() - creationDateA.getTime()
    )
    .map(({ uri, creationDate }, index) => ({
      id: index,
      global_id: index, // eslint-disable-line camelcase
      displayElement: <DownloadLink uri={uri} creationDate={creationDate} isLatestVersion={index === 0} />,
      item: index
    }));

  return (
    <div ref={rootRef} className={css.root}>
      <button onClick={() => setIsOpen(!isOpen)}>
        <DownloadIcon width={14} height={16} />
        <ChevronIcon width={12} height={6} />
      </button>
      {isOpen && (
        <DropDown
          ref={rootRef}
          rootClassName={css.dropdown}
          options={optionLinks}
          handleChange={() => {}}
          handleClose={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default MultiDownloadButton;
